import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>0:43</span> Introduction</li>
                            <li><span>0:57</span> About Guest</li>
                            <li><span>4:03</span> About DIFX Trading Platform</li>
                            <li><span>9:38</span> What Happens to Your Bitcoin When You Die?</li>
                            <li><span>13:33</span> Transitioning from Finance to Technology</li>
                            <li><span>16:03</span> Entrepreneurial Journey</li>
                            <li><span>19:38</span> How’s 2022 for DIFX so far?</li>
                            <li><span>21:08</span> Patent & Licensing in Fintech</li>
                            <li><span>22:54</span> Importance of Educating Potential Clients</li>
                            <li><span>27:28</span> What’s next for DIFX in Dubai?</li>
                            <li><span>29:33</span> Advice for Up & Coming Fintech Entrepreneurs</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;